import { gql } from 'apollo-boost';
import Breadcrumbs from 'core/components/common/Breadcrumbs';
import CenterLoader from 'core/components/common/CenterLoader';
import { useLinks } from 'core/components/linksContext';
import { container, pageHeader } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { useGet52weeksQuery } from 'site/graphql';
import InvestmentDisclaimer from '../dividends/InvestmentDisclaimer';
import SocialShare from '../social-share/SocialShare';
import Service52WeeksGame from './Service52WeeksGame';
import Service52WeeksStart from './Service52WeeksStart';
import { useAuth } from '../auth/AuthProvider';

gql`
    query Get52weeks {
        get52weeks {
            id
            startDate
            startSum
            target
            currency
            investments {
                id
                sum
                weekNumber
            }
        }
    }
`;

const Service52WeeksPage: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const { isLoggedIn } = useAuth();
    const { data, loading } = useGet52weeksQuery({ fetchPolicy: 'network-only', skip: !isLoggedIn });
    const links = useLinks();

    if (loading) {
        return <CenterLoader />;
    }

    return (
        <>
            <div className={classes.header}>
                <h1>52 недели богатства</h1>
            </div>
            <div className={classes.root}>
                <Breadcrumbs
                    contrast={false}
                    items={[
                        { href: links.home.url(), title: 'Главная' },
                        { href: links.servicePage.url(), title: 'Сервисы инвестора' },
                        { title: '52 недели богатства' },
                    ]}
                />
                {data?.get52weeks ? <Service52WeeksGame data={data.get52weeks} /> : <Service52WeeksStart />}
                <InvestmentDisclaimer />
                <SocialShare />
            </div>
        </>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        header: {
            ...pageHeader(theme),
        },
        root: {
            ...container(theme),
            paddingBottom: 1 + 'rem',
        },
    });

export default injectSheet(styles)(Service52WeeksPage);
